var React = require('react');

function MissionUser (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.1","cx":"24","cy":"24","r":"24","fill":"#2D63D7","key":0}),React.createElement("path",{"opacity":"0.3","d":"M24 23C21.7909 23 20 21.2091 20 19C20 16.7909 21.7909 15 24 15C26.2091 15 28 16.7909 28 19C28 21.2091 26.2091 23 24 23Z","fill":"#2D63D7","key":1}),React.createElement("path",{"d":"M15.0007 32.1992C15.3883 27.4265 19.2619 25 23.9833 25C28.7712 25 32.7049 27.2932 32.9979 32.2C33.0096 32.3955 32.9979 33 32.2467 33C28.5411 33 23.0347 33 15.7275 33C15.4767 33 14.9795 32.4592 15.0007 32.1992Z","fill":"#2D63D7","key":2})]);
}

MissionUser.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = MissionUser;

MissionUser.default = MissionUser;
